export default __webpack_public_path__ + "static/media/SWT0030.34I-27130_-25556_0.9fd49e7e.jpg";